// import axios from "axios";

export const state = {
  finalData: []
};

export const getters = {
  allData: (state) => state.finalData
};

export const mutations = {
  setData(state, newValue) {
    state.finalData = newValue;
  }
};

// export const actions = {
//     fetchTodos({ commit }) {
//         axios.get('https://jsonplaceholder.typicode.com/todos', {}).then(res => {
//             commit('setTodos', res.data)
//         })
//     },
// };
